
import Vue from 'vue';
export default Vue.extend({
  name: 'EuRadio',
  props: {
    /**
     * Value of radio input
     */
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    /**
     * Name of radio input
     */
    name: {
      type: String,
      required: true
    },
    /**
     * The value is checked
     */
    checked: {
      type: Boolean,
      required: true
    },
    /**
     * Make radio button disabled
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * The ID, need to string or number
     */
    id: {
      type: [Number, String],
      required: true
    },
    /**
     * Set radio on error
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Custom html template
     */
    template: {
      type: String,
      default: ''
    }
  },
  computed: {
    radioClasses() {
      return {
        checked: this.checked,
        disabled: this.disabled,
        error: this.error
      };
    }
  },
  methods: {
    handleChangeRadio(value: string | number) {
      /**
       * When user change the radio value
       *  @event change
       * @type {function}
       */
      this.$emit('change', value);
    }
  }
});
